import React from "react";

const Privacy = () => {
  return (
    <div>
      <p className="text-2xl">Privacy</p>
    </div>
  );
};

export default Privacy;
